var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.74756 19.7271C1.74756 20.1546 2.09297 20.5 2.5205 20.5H9.42871V11.4179H1.74756V19.7271ZM11.0712 20.5H17.9794C18.407 20.5 18.7524 20.1546 18.7524 19.7271V11.4179H11.0712V20.5ZM19.1389 5.62077H15.5736C15.9021 5.10386 16.0954 4.49034 16.0954 3.83333C16.0954 1.99517 14.6002 0.5 12.762 0.5C11.762 0.5 10.8611 0.944444 10.25 1.64493C9.63886 0.944444 8.73789 0.5 7.73789 0.5C5.89973 0.5 4.40456 1.99517 4.40456 3.83333C4.40456 4.49034 4.59538 5.10386 4.9263 5.62077H1.36108C0.933545 5.62077 0.588135 5.96618 0.588135 6.39372V9.77536H9.42871V5.62077H11.0712V9.77536H19.9118V6.39372C19.9118 5.96618 19.5664 5.62077 19.1389 5.62077ZM9.42871 5.52415H7.73789C6.80553 5.52415 6.04707 4.7657 6.04707 3.83333C6.04707 2.90097 6.80553 2.14251 7.73789 2.14251C8.67026 2.14251 9.42871 2.90097 9.42871 3.83333V5.52415ZM12.762 5.52415H11.0712V3.83333C11.0712 2.90097 11.8297 2.14251 12.762 2.14251C13.6944 2.14251 14.4529 2.90097 14.4529 3.83333C14.4529 4.7657 13.6944 5.52415 12.762 5.52415Z",
    fill: "#4E33E9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5210_865",
    x1: 1.33135,
    y1: 3.83334,
    x2: 20.2196,
    y2: 4.96719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6535E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E33E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftAlt);
export default __webpack_public_path__ + "static/media/giftAlt.05112ed49e77f3402e3ac4bcd914d5e3.svg";
export { ForwardRef as ReactComponent };